import Style from './style'
import Wrapper from '../Wrapper'

const NormalBreak = ({
	countDown,
	timeData,
	infoData,
	logoImg,
	eventName,
	uploadImage,
	loading,
	eventData,
}) => {
	const themeCookie = 'basic'

	// Mock ad list for preview - potentially passed via eventData or static
	const adList = {data: {advertise_timer_list: []}}

	return (
		<Wrapper
			title={eventName}
			infoData={infoData}
			logoImg={logoImg}
			timeData={timeData}
			countDown={countDown}
			eventData={eventData}
		>
			<Style.AdDiv $themeType={themeCookie}>
				<Style.SrcDiv>
					{adList?.data?.advertise_timer_list?.length < 1 ? (
						<p>출력할 광고가 없습니다.</p>
					) : (
						<p>광고 프리뷰 (이미지/비디오)</p>
					)}
				</Style.SrcDiv>
			</Style.AdDiv>
		</Wrapper>
	)
}

export default NormalBreak
